import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/acesso/logradouro/';

class LogradouroService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    
    findAllByCep(cep) {
        return axios.get(API_URL + 'findByCep?cep='+cep, {headers: this.headers});
    }
    
    findAllByCodigo(codigo) {
        return axios.get(API_URL + 'findByCodigo?codigo='+codigo, {headers: this.headers});
    }
}

export default new LogradouroService();